import { Component } from '@angular/core';

@Component({
    selector: 'app-account-settings',
    imports: [],
    templateUrl: './account-settings.component.html',
    styleUrl: './account-settings.component.scss'
})
export class AccountSettingsComponent {

    // File Uploader
    public multiple: boolean = false;

}